import React from "react";
import "./coding skills.css";
import { SiLeetcode } from "react-icons/si";
import { SiGeeksforgeeks } from "react-icons/si";
import { SiHackerrank } from "react-icons/si";

const CodingSkills = () => {
  return (
    <section id="coding skills" className="cskill">
      <h5>Coding Skills</h5>
      <h2>Coding profiles</h2>

      <div className="container coding__container">
        <div className="coding__content">
          <div className="coding__cards">
            <article className="coding__card">
              <SiLeetcode className="coding__icon" />
              <h5>Leetcode</h5>
              <small className="text-light">100+ Problems</small>
              <hr />
              <a href="https://leetcode.com/Rahul_Ray7/">View Profile</a>
            </article>

            <article className="coding__card">
              <SiGeeksforgeeks className="coding__icon" />
              <h5>GeeksForGeeks</h5>
              <small className="text-light">200+ Scores</small>
              <hr />
              <a href="https://auth.geeksforgeeks.org/user/rahul0131/">
                View Profile
              </a>
            </article>

            <article className="coding__card">
              <SiHackerrank className="coding__icon" />
              <h5>HackerRank</h5>
              <small className="text-light">5* Problem Solving</small>
              <hr />
              <a href="https://www.hackerrank.com/rahul0131">View Profile</a>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CodingSkills;
